(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["awards-image-sldier"] && !Shopify.designMode) return;
  try {
    

(function() {
  var MOBILE_MAX = 767;
  var instances = new WeakMap();
  var root = document.querySelector('#award-image_slider .splide');

  function isMobile() {
    return (window.innerWidth || document.documentElement.clientWidth) <= MOBILE_MAX;
  }

  function mount(root) {
    if (instances.get(root) || !window.Splide) return;
    var splide = new Splide(root, {
      type: 'loop',
      perPage: 1,                 // exactly one full tile
      perMove: 1,
      arrows: false,
      pagination: false,
      gap: '12px',               // visual gap between slides
      autoplay: true,
      interval: 6000,
      pauseOnHover: true,
      pauseOnFocus: true,
      padding: { right: '28%', left: 0 },  // partial next slide
      mediaQuery: 'min'          // we handle mount/destroy ourselves
    });
    splide.mount();              // initialize
    instances.set(root, splide);
  }

  function destroy(root) {
    var inst = instances.get(root);
    if (inst) { inst.destroy('completely'); instances.delete(root); }
  }

  function applyAll() {
    document.querySelectorAll('.award-image-cards .splide').forEach(function(root) {
      if (isMobile()) mount(root); else destroy(root);
    });
  }

  document.addEventListener('DOMContentLoaded', applyAll);
  window.addEventListener('resize', applyAll);
  document.addEventListener('shopify:section:load', applyAll);
  document.addEventListener('shopify:section:unload', function(e) {
    var root = e.target && e.target.querySelector ? e.target.querySelector('.award-image-cards .splide') : null;
    if (root) destroy(root);
  });
})();



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
document.addEventListener('DOMContentLoaded',()=>{try{window.CartModule&&window.CartModule.init&&window.CartModule.init()}catch(e){console.error(e)}})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-slider"] && !Shopify.designMode) return;
  try {
    

(function() {
  var MOBILE_MAX = 767;
  var instances = new WeakMap();
  var root = document.querySelector('#collection_slider .splide');

  function isMobile() {
    return (window.innerWidth || document.documentElement.clientWidth) <= MOBILE_MAX;
  }

  function mount(root) {
    if (instances.get(root) || !window.Splide) return;
    var splide = new Splide(root, {
      type: 'loop',
      perPage: 1,                 // exactly one full tile
      perMove: 1,
      arrows: true,
      pagination: false,
      gap: '12px',               // visual gap between slides
      autoplay: true,
      interval: 6000,
      pauseOnHover: true,
      pauseOnFocus: true,
      padding: { right: '28%', left: 0 },  // partial next slide
      mediaQuery: 'min'          // we handle mount/destroy ourselves
    });
    splide.mount();              // initialize
    instances.set(root, splide);
  }

  function destroy(root) {
    var inst = instances.get(root);
    if (inst) { inst.destroy('completely'); instances.delete(root); }
  }

  function applyAll() {
    document.querySelectorAll('.collection-cards .splide').forEach(function(root) {
      if (isMobile()) mount(root); else destroy(root);
    });
  }

  document.addEventListener('DOMContentLoaded', applyAll);
  window.addEventListener('resize', applyAll);
  document.addEventListener('shopify:section:load', applyAll);
  document.addEventListener('shopify:section:unload', function(e) {
    var root = e.target && e.target.querySelector ? e.target.querySelector('.collection-cards .splide') : null;
    if (root) destroy(root);
  });
})();



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-content"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initAccordion(root){
    var items = root.querySelectorAll('.faq-acc__item');
    if (!items.length) return;

    items.forEach(function(item){
      var btn = item.querySelector('.faq-acc__button');
      var panel = item.querySelector('.faq-acc__panel');

      function closePanel(){
        btn.setAttribute('aria-expanded','false');
        panel.style.maxHeight = 0;
      }
      function openPanel(){
        btn.setAttribute('aria-expanded','true');
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }

      // Start closed
      closePanel();

      btn.addEventListener('click', function(){
        var isOpen = btn.getAttribute('aria-expanded') === 'true';

        // close all siblings (accordion behavior)
        items.forEach(function(sib){
          var b = sib.querySelector('.faq-acc__button');
          var p = sib.querySelector('.faq-acc__panel');
          b.setAttribute('aria-expanded','false');
          p.style.maxHeight = 0;
        });

        if (!isOpen) openPanel();
      });

      // Recompute height on resize when open
      window.addEventListener('resize', function(){
        if (btn.getAttribute('aria-expanded') === 'true'){
          panel.style.maxHeight = panel.scrollHeight + 'px';
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('.faq-mip').forEach(initAccordion);
  });
  document.addEventListener('shopify:section:load', function(e){
    var el = e.target && e.target.querySelector ? e.target.querySelector('.faq-mip') : null;
    if (el) initAccordion(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-faq"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initAccordion(root){
    var items = root.querySelectorAll('.faq-acc__item');
    if (!items.length) return;

    items.forEach(function(item){
      var btn = item.querySelector('.faq-acc__button');
      var panel = item.querySelector('.faq-acc__panel');

      function closePanel(){
        btn.setAttribute('aria-expanded','false');
        panel.style.maxHeight = 0;
      }
      function openPanel(){
        btn.setAttribute('aria-expanded','true');
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }

      // Start closed
      closePanel();

      btn.addEventListener('click', function(){
        var isOpen = btn.getAttribute('aria-expanded') === 'true';

        // close all siblings (accordion behavior)
        items.forEach(function(sib){
          var b = sib.querySelector('.faq-acc__button');
          var p = sib.querySelector('.faq-acc__panel');
          b.setAttribute('aria-expanded','false');
          p.style.maxHeight = 0;
        });

        if (!isOpen) openPanel();
      });

      // Recompute height on resize when open
      window.addEventListener('resize', function(){
        if (btn.getAttribute('aria-expanded') === 'true'){
          panel.style.maxHeight = panel.scrollHeight + 'px';
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('.faq-mip').forEach(initAccordion);
  });
  document.addEventListener('shopify:section:load', function(e){
    var el = e.target && e.target.querySelector ? e.target.querySelector('.faq-mip') : null;
    if (el) initAccordion(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-product"] && !Shopify.designMode) return;
  try {
    


(function() {


  var MOBILE_MAX = 767;
  var instances = new WeakMap();
  var root = document.querySelector('#recommendations_slider .splide');

  function isMobile() {
    return (window.innerWidth || document.documentElement.clientWidth) <= MOBILE_MAX;
  }

  function mount(root) {
    if (instances.get(root) || !window.Splide) return;
    var splide = new Splide(root, {
      type: 'loop',
      perPage: 1,                 // exactly one full tile
      perMove: 1,
      arrows: false,
      pagination: false,
      gap: '0',               // visual gap between slides
      autoplay: true,
      interval: 9000,
      pauseOnHover: true,
      pauseOnFocus: true,
      padding: 0,
      margin: 0,
      mediaQuery: 'min'          // we handle mount/destroy ourselves
    });
    splide.mount();              // initialize
    instances.set(root, splide);
  }

  function destroy(root) {
    var inst = instances.get(root);
    if (inst) { inst.destroy('completely'); instances.delete(root); }
  }

  function applyAll() {
    document.querySelectorAll('.recommendations-cards .splide').forEach(function(root) {
      if (isMobile()) mount(root); else destroy(root);
    });
  }

  document.addEventListener('DOMContentLoaded', applyAll);
  window.addEventListener('resize', applyAll);
  document.addEventListener('shopify:section:load', applyAll);
  document.addEventListener('shopify:section:unload', function(e) {
    var root = e.target && e.target.querySelector ? e.target.querySelector('.recommendations-cards .splide') : null;
    if (root) destroy(root);
  });

})();

(function() {
  const root = document.currentScript.closest('.product-recommendations');
  if (!root) return;

  const list = root.querySelector('[data-recommendations-list]');
  const url = root.getAttribute('data-url');
  if (!url || !list) return;

  function loadRecommendations() {
    fetch(url, { credentials: 'same-origin' })
      .then(res => res.text())
      .then(html => {
        const temp = document.createElement('div');
        temp.innerHTML = html;
        const newSection = temp.querySelector('.product-recommendations');
        const newList = newSection && newSection.querySelector('[data-recommendations-list]');
        if (newList && newList.innerHTML.trim().length > 0) {
          list.innerHTML = newList.innerHTML;
        }
        // If still empty, fallback already handled by Liquid output
      })
      .catch(() => {});
  }

  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        io.unobserve(root);
        loadRecommendations();
      }
    }, { rootMargin: '0px 0px 200px 0px' });
    io.observe(root);
  } else {
    loadRecommendations();
  }
})();



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trust-banner"] && !Shopify.designMode) return;
  try {
    


(function() {
  var MOBILE_MAX = 767; // enable slider at <= 767px
  var instances = new WeakMap(); // map root -> Splide instance
  var root = document.querySelector('.trust-banner .splide');

  function initSplideFor(root) {
    if (instances.get(root)) return;
    var splide = new Splide(root, {
      type: 'loop',
      perPage: 1,
      gap: '16px',
      arrows: false,
      pagination: false,
      autoplay: true,
      interval: 6000,
      pauseOnHover: true,
      pauseOnFocus: true,
      drag: true,
      mediaQuery: 'max',
      breakpoints: {
        [MOBILE_MAX]: { perPage: 1 }
      }
    });
    splide.mount();
    instances.set(root, splide);
  }

  function destroyFor(root) {
    var inst = instances.get(root);
    if (inst) {
      inst.destroy('completely');
      instances.delete(root);
    }
  }

  function isMobile() {
    return (window.innerWidth || document.documentElement.clientWidth) <= MOBILE_MAX;
  }

  function applyAll() {
    var sliders = document.querySelectorAll('.icon-row .splide');
    sliders.forEach(function(root) {
      if (isMobile()) {
        initSplideFor(root);
      } else {
        destroyFor(root);
      }
    });
  }

  // Initial
  document.addEventListener('DOMContentLoaded', applyAll);

  // On resize
  window.addEventListener('resize', function() {
    applyAll();
  });

  // If content is added dynamically (e.g., sections loaded), re-apply
  document.addEventListener('shopify:section:load', applyAll);
  document.addEventListener('shopify:section:unload', function(e) {
    var root = e.target && e.target.querySelector ? e.target.querySelector('.icon-row .splide') : null;
    if (root) destroyFor(root);
  });
})();




  } catch(e) { console.error(e); }
})();
})();
